// src/shared/ui/notifications/ToastContainer.tsx
import React, { useEffect, useState } from 'react';
import { toast } from './toast';
import { Toast } from './types';

const colors = {
  success: 'bg-green-500',
  error: 'bg-red-500',
  info: 'bg-blue-500',
  warning: 'bg-yellow-500',
};

const ToastContainer = () => {
  const [items, setItems] = useState<Toast[]>([]);

  useEffect(() => {
    return toast.subscribe(setItems);
  }, []);

  return (
    <div
      className="fixed top-4 right-4 space-y-2"
      style={{ zIndex: 2147483647 }} // ✅ z-index maximum possible
    >
      {items.map((t) => (
        <div
          key={t.id}
          className={`${colors[t.type]} text-white px-4 py-3 rounded-lg shadow-2xl animate-fade-in max-w-sm break-words pointer-events-auto`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;